import { Row, Col } from "react-bootstrap";
import InputSearch from "../../../../components/inputs/InputSelectSearch";

const DocumentForm = ({
  values,
  touched,
  errors,
  onChange,
  handleBlur,
  showForm,
  setShowForm,
  setFieldValue,
  delitos,
  materias,
  tiposCarpeta,
  sistemas,
  instancias,
  amnistia,
}: {
  values: any;
  touched: any;
  errors: any;
  onChange: any;
  handleBlur: any;
  showForm: any;
  setShowForm: any;
  setFieldValue: any;
  delitos: any;
  materias: any;
  tiposCarpeta: any;
  sistemas: any;
  instancias: any;
  amnistia: boolean;
}) => {
  return (
    <div>
      <Row className="d-flex justify-content-around mt-3">
        {values.typeDocument !== "ACUERDOS" && (
          <Col xs={12} md={3}>
            <InputSearch
              label="Tipo de Carpeta"
              name="folderType"
              value={values.folderType}
              touched={touched.folderType}
              error={errors.folderType}
              values={tiposCarpeta}
              labelVal="name"
              valueVal="_id"
              onChangeMethod={onChange}
              onBlurMethod={handleBlur}
              disabled={amnistia}
            />
          </Col>
        )}
        {!amnistia && (
          <Col xs={12} md={3}>
            <InputSearch
              label="Materia"
              name="subject"
              value={values.subject}
              touched={touched.subject}
              error={errors.subject}
              values={materias}
              labelVal="name"
              valueVal="_id"
              onChangeMethod={onChange}
              onBlurMethod={handleBlur}
            />
          </Col>
        )}
        {values.typeDocument !== "ACUERDOS" &&
          (!amnistia && (
            <>
              <Col xs={12} md={3}>
                <InputSearch
                  label="Juicio"
                  name="delito"
                  value={values.delito as string}
                  touched={touched.delito}
                  error={errors.delito}
                  values={delitos}
                  disabled={
                    values.subject && delitos.length === 0 ? true : false
                  }
                  labelVal="name"
                  valueVal="_id"
                  onChangeMethod={onChange}
                  onBlurMethod={handleBlur}
                />
              </Col>
            </>
          ))}
      </Row>

      
    </div>
  );
};

export default DocumentForm;
